import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Input } from 'loyal-react'
import { connect } from 'react-redux'
import { SendMail } from './actions'

class Unavailable extends Component {
  name = '';
  mail = '';

  MessageInputName () {
    if (this.props.filled.Name.error !== undefined) return false
    else return null
  }

  MessageInputMail () {
    if (this.props.filled.Email.error !== undefined) return false
    else return null
  }

  render () {
    return (
      <div>
        <div className='card-buttons row px-2 border-color-ui-3 pb-3 mx-0 py-3 d-none'>
          <div className='card-button col-6 d-none'>
            <Input
              id='Name'
              label='Nome'
              className='col-12'
              required
              onChange={e => {
                this.Nome = e.target.value
              }}
              data-error={'Nome Invalido'}
              valid={this.MessageInputName()}
              value={this.Nome}
            />
          </div>
          <div className='card-button col-6 d-none'>
            <Input
              id='mail'
              label='mail'
              className='col-12'
              required
              onChange={e => {
                this.mail = e.target.value
              }}
              data-error={'mail Invalido'}
              valid={this.MessageInputMail()}
              value={this.mail}
            />
          </div>
        </div>
        <div className='row my-2 border-color-ui-4 mx-0'>
          <div className='card-button col-12 px-3'>
            <div className='col-12 pb-2 px-0'>
              <h3 className='txt-uppercase color-error txt-body txt-font-body'>
                <strong>Produto indisponivel</strong>
              </h3>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

Unavailable.propTypes = {
  filled: PropTypes.object
}

const mapStateToProps = ({ unAvailable }) => ({
  filled: unAvailable.filled
})

const mapDispatchToProps = dispatch => ({
  SendMail: mail => dispatch(SendMail(mail))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Unavailable)



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductDetail/RedemptionSection/Unvailable/Unavailable.js